module.exports = __webpack_public_path__ + "img/screens.330e182c.png";